import { StepsNavigationName } from '../../../../config/services';
import { formatDate } from '../../../../helpers/dates';
import { parseFormDataValue } from '../../../../helpers/parseFormDataValue';
import { NullValueGuard } from '../../../../middlewares/NullValueGuard';
import { AccordionData } from '../../../Accordion/Accordion';
import { HealthDataFieldName } from '../../constants';
import { PreviewFilesList } from '../../PreviewFilesList';

import { HealthFormDataProps } from './types';

interface PreviewProps {
  formData: HealthFormDataProps;
}

export const previewHealthData = ({ formData }: PreviewProps): AccordionData => {
  return {
    title: StepsNavigationName.health,
    content: (
      <div className="custom-columns custom-columns_grey-bg custom-columns_default-gap">
        <div className="custom-columns__row custom-columns__row_padding-tiny">
          <div className="custom-columns__col">
            <div className="custom-columns__title">Тип документа, який підтверджує стан здоров’я</div>
            <div className="custom-columns__info">
              <NullValueGuard>
                {parseFormDataValue(formData[HealthDataFieldName.healthDataDocType])?.label}
              </NullValueGuard>
            </div>
          </div>
          <div className="custom-columns__col">
            <div className="custom-columns__title">Серія та номер</div>
            <div className="custom-columns__info">
              <NullValueGuard>{formData[HealthDataFieldName.healthDataDocSerialNumber]}</NullValueGuard>
            </div>
          </div>
          <div className="custom-columns__col">
            <div className="custom-columns__title">Орган видачі</div>
            <div className="custom-columns__info">
              <NullValueGuard>{formData[HealthDataFieldName.healthDataDocIssuingAuthority]}</NullValueGuard>
            </div>
          </div>
        </div>
        <div className="custom-columns__row custom-columns__row_padding-tiny">
          <div className="custom-columns__col">
            <div className="custom-columns__title">Дата видачі</div>
            <div className="custom-columns__info">
              <NullValueGuard>{formatDate(formData[HealthDataFieldName.healthDataDocIssueDate])}</NullValueGuard>
            </div>
          </div>
          <div className="custom-columns__col">
            <div className="custom-columns__title">Термін дії</div>
            <div className="custom-columns__info">
              <NullValueGuard>{formatDate(formData[HealthDataFieldName.healthDataDocExpireDate])}</NullValueGuard>
            </div>
          </div>
          <div className="custom-columns__col">
            <div className="custom-columns__title">Документ, що підтверджує стан здоров’я</div>
            <div className="custom-columns__info">
              <NullValueGuard>
                {formData[HealthDataFieldName.healthDataDocument] ? (
                  <PreviewFilesList files={formData[HealthDataFieldName.healthDataDocument]} />
                ) : null}
              </NullValueGuard>
            </div>
          </div>
        </div>
      </div>
    ),
  };
};
